<template>
  <div class="row col-hspace form-classic">
    <div class="col-xs-12 col-vbspace">
      <label>Année(s)</label>

      <div class="col-xs-12">
        <select
          v-model="start"
          id="start-date"
          name="start-date"
          class="classic-select--v2 tcenter"
        >
          <option
            v-for="(option, index) in options"
            :value="option.value"
            :key="index"
          >
            {{ option.value }}
          </option>
        </select>
      </div>

      <div class="col-xs-12">
        <select
          v-model="end"
          id="end-date"
          name="end-date"
          class="classic-select--v2 tcenter"
        >
          <option
            v-for="(option, index) in options"
            :value="option.value"
            :key="index"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      start: undefined,
      end: undefined,
    };
  },

  watch: {
    start() {
      this.update();
    },
    end() {
      this.update();
    },
  },

  computed: {
    year() {
      return new Date().getFullYear();
    },

    options() {
      return [
        { value: this.year - 5 },
        { value: this.year - 4 },
        { value: this.year - 3 },
        { value: this.year - 2 },
        { value: this.year - 1 },
        { value: this.year },
        { value: this.year + 1 },
      ];
    },
  },

  created() {
    this.start = this.year - 1;
    this.end = this.year;
  },

  methods: {
    update() {
      this.$emit('update', {
        start: this.start,
        end: this.end,
      });
    },
  },
};
</script>
